import { createFileRoute } from "@tanstack/react-router";
import AdminUserDetailPage from "@/pages/admin/users/detail";
import { useUsersPermissions } from "@/pages/admin/users";

export const Route = createFileRoute("/app/admin/users/$userId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userId } = Route.useParams();
  const { userCanEditAllUsers, userCanViewAllUsers, userCanViewAllRequests } = useUsersPermissions();

  return (
    <AdminUserDetailPage
      subjectUserId={Number(userId)}
      userCanEditAllUsers={userCanEditAllUsers}
      userCanViewAllUsers={userCanViewAllUsers}
      userCanViewAllRequests={userCanViewAllRequests}
    />
  );
}
